var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isAllowed
    ? _c(
        "app-calendar-widget",
        { staticClass: "set-height" },
        [
          _c("template", { slot: "title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ]),
        ],
        2
      )
    : _c("app-missing-module", {
        attrs: { "module-id": 71, title: _vm.title, "disable-max-width": "" },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }